import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionsData, IQuestionMappingPayload } from "../../../Pages/Questions/IQuestions";

export const QuestionMappingSlice = createSlice({
    name: "QuestionMappingSlice",
    initialState: {} as IReduxState<IQuestionsData>,
    reducers: {
        listQuestionMapping: (state, _: PayloadAction<IQuestionMappingPayload>) => {
            state.isLoading = true;
        },
        successlistQuestionMapping: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistQuestionMapping: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearQuestionMappingResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    failurelistQuestionMapping,
    listQuestionMapping,
    successlistQuestionMapping,
    clearQuestionMappingResponse,
} = QuestionMappingSlice.actions;

export default QuestionMappingSlice.reducer;
